(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("lodash")) : factory(root["lodash"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 20);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var repeaterItemsUtils = __webpack_require__(19);

module.exports = {
  items: {
    getAddedItems: repeaterItemsUtils.getAddedItems,
    getRemovedItems: repeaterItemsUtils.getRemovedItems,
    getTemplateCompsId: repeaterItemsUtils.getTemplateCompIds
  },
  structure: {
    getUniqueDisplayedId: repeaterItemsUtils.getUniqueDisplayedId,
    getOriginalId: repeaterItemsUtils.getOriginalId,
    getItemId: repeaterItemsUtils.getItemId,
    SPLITTED_DATA_TYPES: repeaterItemsUtils.SPLITTED_DATA_TYPES
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getVideoUrl(videoId) {
  var baseUrl = 'https://dailymotion.com/video/';
  return baseUrl + videoId;
}

function getVideoIdFromUrl(url) {

  var urlRegex = /dailymotion\.com\/(?:video|playlist)\/([^_/]+)/gi;
  var match = urlRegex.exec(url);
  if (match && match.length && match[1]) {
    //if there is a match, the second group is the id we want
    return match[1];
  }
}

module.exports = {
  getVideoUrl: getVideoUrl,
  getVideoIdFromUrl: getVideoIdFromUrl
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getVideoUrl(videoId) {
  var baseUrlPrefix = 'https://www.facebook.com/';
  return baseUrlPrefix + videoId;
}

function getVideoIdFromUrl(url) {
  var urlRegex = /facebook\.com\/(.+\/videos\/[A-Za-z0-9._%-]*)/gi;
  var match = urlRegex.exec(url);
  if (match && match.length && match[1]) {
    //if there is a match, the second group is the id we want
    return match[1];
  }
}

module.exports = {
  getVideoUrl: getVideoUrl,
  getVideoIdFromUrl: getVideoIdFromUrl
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getVideoUrl(videoId) {
  var baseUrlPrefix = 'https://vimeo.com/';
  return baseUrlPrefix + videoId;
}

function getVideoIdFromUrl(url) {
  // TODO: add support for additional vimeo url formats
  var vimeoUrlRegex = /vimeo\.com\/(\d+)$/gi;
  var match = vimeoUrlRegex.exec(url);
  if (match && match.length && match[1]) {
    //if there is a match, the second group is the id we want
    return match[1];
  }
}

module.exports = {
  getVideoUrl: getVideoUrl,
  getVideoIdFromUrl: getVideoIdFromUrl
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getVideoUrl(videoId) {
  var baseUrlPrefix = 'https://www.youtube.com/watch?v=';
  return baseUrlPrefix + videoId;
}

function getVideoIdFromUrl(url) {
  // TODO: add support for additional youtube url formats
  // Test for long youtube url: http://youtube.com/watch?[...&]v=[VIDEO_ID]
  var YTLongUrl = /(?:youtube\.com\/watch[^\s]*[\?&]v=)([\w-]+)/g;
  // Test for short youtube url: http://youtu.be/[VIDEO_ID]
  var YTShortUrl = /(?:youtu\.be\/)([\w-]+)/g;

  var match = YTLongUrl.exec(url) || YTShortUrl.exec(url);
  if (match && match.length && match[1]) {
    //if there is a match, the second group is the id we want
    return match[1];
  }
}

module.exports = {
  getVideoUrl: getVideoUrl,
  getVideoIdFromUrl: getVideoIdFromUrl
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var CHARS_TO_ADD = '...';
var NUM_OF_CHARS_TO_KEEP = 3;
var BG_VIDEO_DEFAULTS = {
  opacity: 1,
  autoplay: true,
  loop: true,
  preload: 'auto',
  mute: true
};
var MEDIA_PLAYER_DEFAULTS = {
  opacity: 1,
  autoplay: false,
  loop: false,
  preload: 'none',
  mute: false
};
var TITLE_LENGTH_LIMIT = 100;

function url2uri(url) {
  return url.replace(/^(.*[\/])/, '');
}

function getIdFromUrl(fileUrl) {
  var result = fileUrl.match(/(?:\/|^)([0-9a-fA-F_]+)(?:\/|$)/);
  return result.length > 1 ? result[1] : '';
}

function fixMediaTitleLength(value, lengthLimit) {
  if (value.length <= lengthLimit) {
    return value;
  }
  var arr = value.split('');
  var numOfCharsToRemove = value.length - lengthLimit + CHARS_TO_ADD.length;
  var isFileTypeSuffix = value.lastIndexOf('.') > value.length - numOfCharsToRemove - NUM_OF_CHARS_TO_KEEP;
  var fileTypeSuffixIndex = isFileTypeSuffix ? value.lastIndexOf('.') : value.length - 1;
  var removeIndex = fileTypeSuffixIndex - numOfCharsToRemove - NUM_OF_CHARS_TO_KEEP;
  arr.splice(removeIndex, numOfCharsToRemove, CHARS_TO_ADD);
  return arr.join('');
}

/**
 * extracts the generated images from the video payload
 * @param fileInfo
 * @returns {[string]} images uri
 */
function parseVideoPosters(fileInfo) {
  var fileOutput = fileInfo.fileOutput || fileInfo.file_output;
  return _.map(fileOutput.image, function (image) {
    return url2uri(image.url);
  });
}

/**
 * extracts the video qualities from the video payload
 * @param fileInfo
 * @returns {[{width: number, height: number, quality: string, url: string} || {}]} qualities array
 */
function parseVideoQualities(fileInfo) {
  var fileOutput = fileInfo.fileOutput || fileInfo.file_output;
  var mp4Videos = _.filter(fileOutput.video, { format: 'mp4' });
  var storyboard = _.head(_.get(fileOutput, 'storyboard'));
  var qualities = _.map(mp4Videos, function (quality) {
    return _.pick(quality, ['width', 'height', 'quality', 'url']);
  });

  if (storyboard) {
    qualities.push({
      quality: 'storyboard',
      width: storyboard.width,
      height: storyboard.height,
      url: storyboard.url
    });
  }

  return qualities;
}

/**
 * parse media manager video file response into WixVideo object scheme
 * @param fileInfo - media manager, video file object response (https://docs.google.com/a/wix.com/document/d/1_fqnV0JcTfMHVpqKJIR9jFV-l6YGxv8_7cc3XQ7I2OY)
 * @param info - media manager, folder information
 * @returns {{type: string, title: *, videoId: string, duration: number, posterImageRef: *, generatedPosters: string[], qualities: ({width: number, height: number, quality: string, url: string}|{})[], artist: {name: (*|string), id: (*|string)}, hasAudio: boolean, fps: (string|*)}}
 * https://docs.google.com/a/wix.com/document/d/1BcbazImlny7Y5k4dE5B6n-FD4_NkXAeluefsl8324Js
 */
function parseVideoFileInfo(fileInfo, info) {
  var fileInput = fileInfo.fileInput || fileInfo.file_input;
  var fileOutput = fileInfo.fileOutput || fileInfo.file_output;
  var videoId = getIdFromUrl(fileInfo.fileUrl || fileInfo.file_name);
  var title = fixMediaTitleLength(fileInfo.title, TITLE_LENGTH_LIMIT);
  var qualities = parseVideoQualities(fileInfo);
  // parse poster - get the first item in data
  var imageData = _.head(fileOutput.image);
  var posterImageRef = {
    type: 'Image',
    width: imageData.width,
    height: imageData.height,
    uri: url2uri(imageData.url),
    description: info.path ? info.path : undefined
  };

  return {
    type: 'WixVideo',
    title: title,
    videoId: videoId,
    duration: +(fileInput.duration / 1000).toFixed(2),
    posterImageRef: posterImageRef,
    generatedPosters: parseVideoPosters(fileInfo),
    qualities: qualities,
    artist: { name: fileInfo.vendor || '', id: fileInfo.reference || '' },
    hasAudio: _.head(fileOutput.video).audio_bitrate !== -1,
    fps: _.get(_.head(fileOutput.video), 'fps', '').toString()
  };
}

function getVideoBackgroundObject(fileInfo, info) {
  var mediaObject = parseVideoFileInfo(fileInfo, info);
  return _.assign(mediaObject, BG_VIDEO_DEFAULTS);
}

function getMediaPlayerVideoObject(fileInfo, info) {
  var mediaObject = parseVideoFileInfo(fileInfo, info);
  return _.assign(mediaObject, MEDIA_PLAYER_DEFAULTS);
}

function getVideoPosterObject(videoId, uri, width, height) {
  return {
    type: 'WixVideo',
    videoId: videoId,
    posterImageRef: {
      type: 'Image',
      uri: uri,
      width: width,
      height: height
    }
  };
}

/**
 *
 * @param fileInfo
 * @param info - media manager, folder information
 * @returns {{uri: *, title: *, width: *, height: *}}
 */
function getImageBackgroundObject(fileInfo, info) {
  return {
    type: 'Image',
    uri: fileInfo.fileName,
    title: fixMediaTitleLength(fileInfo.title, TITLE_LENGTH_LIMIT),
    description: info.path,
    width: fileInfo.width,
    height: fileInfo.height,
    artist: { name: fileInfo.vendor || '', id: fileInfo.reference || '' }
  };
}

module.exports = {
  getVideoBackgroundObject: getVideoBackgroundObject,
  getVideoPosterObject: getVideoPosterObject,
  getMediaPlayerVideoObject: getMediaPlayerVideoObject,
  getImageBackgroundObject: getImageBackgroundObject,
  fixMediaTitleLength: fixMediaTitleLength
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function getSvgV1SkinName(url) {
  var split = url.replace('_', '.').replace('/', '.').split('.');
  return [split[2], split[3], 'svg_' + split[1], split[4]].join('.'); // eslint-disable-line
}

function getSvgV2SkinName(url) {
  //Example fileName: shapes/083ab0e246b24019a44c3d1e7096147f.svg
  //Example skinName: svgshape.v2.Svg_083ab0e246b24019a44c3d1e7096147f
  var regEx = /^shapes\/([a-z0-9]{32})\.svg$/i;
  var partsArr = regEx.exec(url);
  var md5Hash = partsArr[1];
  return 'svgshape.v2.Svg_' + md5Hash; // eslint-disable-line
}

module.exports = {
  parseSvgSkinFromUrl: function parseSvgSkinFromUrl(url) {
    return _.includes(url, '.v1.') ? getSvgV1SkinName(url) : getSvgV2SkinName(url);
  }
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var youtubeVideoUtils = __webpack_require__(5);
var vimeoVideoUtils = __webpack_require__(4);
var dailymotionVideoUtils = __webpack_require__(2);
var facebookVideoUtils = __webpack_require__(3);
var _ = __webpack_require__(0);

// TODO: unite with santa viewer

var VIDEO_UTILS_PROVIDERS = {
  YOUTUBE: youtubeVideoUtils,
  VIMEO: vimeoVideoUtils,
  DAILYMOTION: dailymotionVideoUtils,
  FACEBOOK: facebookVideoUtils
};

function getMethodForType(videoType, methodName) {
  return VIDEO_UTILS_PROVIDERS[videoType.toUpperCase()] && VIDEO_UTILS_PROVIDERS[videoType][methodName];
}

/**
 * @param {{videoType: string, videoId: string}} videoData
 * @returns {string}
 */
function getVideoUrl(videoData) {
  if (videoData && videoData.videoType && videoData.videoId) {
    var videoUrlGetter = getMethodForType(videoData.videoType, 'getVideoUrl');
    return videoUrlGetter && videoUrlGetter(videoData.videoId) || '';
  }

  return '';
}

/**
 * @param {string} videoUrl
 * @returns {videoData}
 */
function getVideoDataFromUrl(videoUrl) {
  var videoData = void 0;
  _.forEach(VIDEO_UTILS_PROVIDERS, function (methods, videoType) {
    var videoIdGetter = getMethodForType(videoType, 'getVideoIdFromUrl');
    var videoId = videoIdGetter && videoIdGetter(videoUrl);
    if (!_.isEmpty(videoId)) {
      videoData = {
        videoType: videoType,
        videoId: videoId
      };
      return false; // break forEach
    }
  });
  return videoData;
}

module.exports = {
  getVideoUrl: getVideoUrl,
  getVideoDataFromUrl: getVideoDataFromUrl,
  videoTypes: {
    YOUTUBE: 'YOUTUBE',
    VIMEO: 'VIMEO',
    DAILYMOTION: 'DAILYMOTION',
    FACEBOOK: 'FACEBOOK'
  }
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var CHILDREN = 'children';
var REPEATER_TYPE = 'wysiwyg.viewer.components.Repeater';

function getAllCompsUnderRoot(model, rootId) {
  var compsUnderRoot = [rootId];
  for (var i = 0; i < compsUnderRoot.length; i++) {
    var children = _.get(model.components, [compsUnderRoot[i], CHILDREN]) || [];
    compsUnderRoot.push.apply(compsUnderRoot, children);
  }
  compsUnderRoot.shift();

  return compsUnderRoot;
}

function isTemplateComp(model, compId) {
  var getCompParent = function getCompParent(compId) {
    return _.get(model, ['components', compId, 'parent']);
  };
  var isCompRepeater = function isCompRepeater(compId) {
    return _.get(model, ['components', currentParent, 'type']) === REPEATER_TYPE;
  };
  var currentComp = compId;
  var currentParent = getCompParent(currentComp);
  // search for the parent that is also direct child of a repeater, if exist
  while (currentParent && !isCompRepeater(currentParent)) {
    currentComp = currentParent;
    currentParent = getCompParent(currentComp);
  }
  // if the direct child is in the repeater's children array, then its a template component, otherwise its a displayed only component
  return isCompRepeater(currentParent) && _.includes(_.get(model, ['components', currentParent, 'children']), currentComp);
}

module.exports = {
  getAllCompsUnderRoot: getAllCompsUnderRoot,
  isTemplateComp: isTemplateComp
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var repeaterHooks = __webpack_require__(17);

module.exports = {
  repeaters: repeaterHooks
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ = __webpack_require__(0);
var repeaterUtils = __webpack_require__(1);
var modelUtils = __webpack_require__(9);
var HooksManager = __webpack_require__(18);

var DATA = 'data',
    FULL_DATA = 'fullData',
    DESIGN = 'design',
    STATE = 'state',
    TYPE = 'type',
    PROPS = 'props',
    PARENT = 'parent',
    EVENTS = 'events',
    LAYOUT = 'layout',
    BEHAVIOR = 'behavior',
    PUBLIC_API = 'publicAPI',
    IS_DISPLAYED = 'isDisplayed',
    STYLE = 'style',
    ID = 'id',
    CHILDREN = 'children',
    DISPLAYED_ONLY_COMPONENTS = 'displayedOnlyComponents',
    DISPLAYED_ROOT = 'displayedRoot';

var GLOBAL_SCOPE = 'GLOBAL_SCOPE';
var COMPONENT_SCOPE = 'COMPONENT_SCOPE';

function RemoteModelInterface(modelJson, onUpdateCallback, options) {
  this._model = modelJson || {
    components: {},
    connections: {},
    componentsScopes: {},
    navigation: {},
    siteStructure: {},
    eventHandlers: {},
    EventTypes: {},
    sessionInfo: {},
    siteMemberData: { uid: null, permissions: null, onUserLogin: [] },
    scopesHierarchy: [{ type: GLOBAL_SCOPE, id: GLOBAL_SCOPE, additionalData: {} }]
  };
  this._onUpdateCallback = onUpdateCallback;

  var optionsHookManager = _.get(options, '_hooksManager');
  var optionsTransaction = _.get(options, '_transaction');
  this._hooksManager = optionsHookManager ? optionsHookManager : new HooksManager();
  this._transaction = optionsTransaction ? optionsTransaction : { _onTransaction: false, _transactionData: {} };
}

function getCurrentScopeId(onlyNested) {
  return onlyNested ? _.get(this._model.scopesHierarchy, '0.id') : _.map(this._model.scopesHierarchy, function (scopeHierarchy) {
    return _.get(scopeHierarchy, 'id');
  });
}

function generateDefaultCompStructure() {
  var _ref;

  return _ref = {}, _defineProperty(_ref, PARENT, null), _defineProperty(_ref, STATE, {}), _defineProperty(_ref, TYPE, null), _defineProperty(_ref, DATA, {}), _defineProperty(_ref, FULL_DATA, {}), _defineProperty(_ref, DESIGN, {}), _defineProperty(_ref, PROPS, {}), _defineProperty(_ref, LAYOUT, {}), _defineProperty(_ref, EVENTS, []), _defineProperty(_ref, IS_DISPLAYED, false), _defineProperty(_ref, ID, null), _defineProperty(_ref, PUBLIC_API, {}), _defineProperty(_ref, STYLE, {}), _defineProperty(_ref, CHILDREN, []), _defineProperty(_ref, DISPLAYED_ONLY_COMPONENTS, []), _defineProperty(_ref, DISPLAYED_ROOT, null), _ref;
};

RemoteModelInterface.prototype.addComponent = function (compId, compDescriptor) {
  var comp = generateDefaultCompStructure();
  for (var key in comp) {
    comp[key] = compDescriptor[key] || comp[key];
  }
  comp[PARENT] = compDescriptor[PARENT];
  comp[TYPE] = compDescriptor[TYPE];
  comp[ID] = compDescriptor[ID];
  comp[DISPLAYED_ROOT] = compDescriptor[DISPLAYED_ROOT];
  this._model.components[compId] = comp;
  this._model.componentsScopes[compId] = GLOBAL_SCOPE;
};

RemoteModelInterface.prototype.addNavigation = function (navigationData) {
  this._model.navigation = navigationData;
};

RemoteModelInterface.prototype.addSiteStructure = function (siteStructureData) {
  this._model.siteStructure = siteStructureData;
};

RemoteModelInterface.prototype.addConnections = function (connectionsModel) {
  this._model.connections = connectionsModel;
};

RemoteModelInterface.prototype.resetComponentsScope = function () {
  var _this = this;

  for (var compId in this._model.components) {
    var displayedOnlyCompIds = this._model.components[compId].displayedOnlyComponents;

    displayedOnlyCompIds.forEach(function (displayedOnlyCompId) {
      return _this._model.componentsScopes[displayedOnlyCompId] = null;
    });
  }
};

RemoteModelInterface.prototype.addEventTypes = function (EventTypes) {
  this._model.EventTypes = EventTypes;
};

RemoteModelInterface.prototype.addSiteMemberData = function (siteMemberData) {
  var shouldTriggerOnLoginCallback = siteMemberData.uid && siteMemberData.uid !== this._model.siteMemberData.uid;
  _.assign(this._model.siteMemberData, siteMemberData);
  if (shouldTriggerOnLoginCallback) {
    var onUserLoginCallbacks = this._model.siteMemberData.onUserLogin;
    _.forEach(onUserLoginCallbacks, function (callback) {
      callback(siteMemberData);
    });
  }
};

RemoteModelInterface.prototype.addOnUserLoginCallback = function (callback) {
  this._model.siteMemberData.onUserLogin.push(callback);
};

RemoteModelInterface.prototype.addSessionInfoProp = function (addSessionInfoProp) {
  _.assign(this._model.sessionInfo, addSessionInfoProp);
};

//Getters

RemoteModelInterface.prototype.getComp = function (compId) {
  return _.cloneDeep(_.get(this._model.components, compId));
};

RemoteModelInterface.prototype.getState = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, STATE]));
};

RemoteModelInterface.prototype.getData = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, DATA]));
};

RemoteModelInterface.prototype.getStyle = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, STYLE]));
};

RemoteModelInterface.prototype.getDesign = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, DESIGN]));
};

RemoteModelInterface.prototype.getType = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, TYPE]));
};

RemoteModelInterface.prototype.getProps = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, PROPS]));
};

RemoteModelInterface.prototype.getEvents = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, EVENTS]));
};

RemoteModelInterface.prototype.getLayout = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, LAYOUT]));
};

RemoteModelInterface.prototype.getId = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, ID]));
};

RemoteModelInterface.prototype.getEventTypes = function () {
  return _.cloneDeep(this._model.EventTypes);
};

RemoteModelInterface.prototype.getPublicAPI = function (compId) {
  var publicApi = _.get(this._model.components, [compId, PUBLIC_API]);
  if (_.isFunction(publicApi)) {
    return publicApi;
  }
  return _.cloneDeep(publicApi);
};

RemoteModelInterface.prototype.getCallbackById = function (callbackId, newFormat) {
  var eventHandler = this._model.eventHandlers[callbackId]; // TODO - backward compatibility - remove after SDK next release
  if (newFormat) {
    return eventHandler;
  }
  return _.get(eventHandler, 'callback');
};

RemoteModelInterface.prototype.getParent = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, PARENT]));
};

RemoteModelInterface.prototype.getChildren = function (parentId) {
  return _.clone(_.get(this._model.components, [parentId, CHILDREN]));
};

RemoteModelInterface.prototype.getSiteStructure = function () {
  return _.cloneDeep(this._model.siteStructure);
};

RemoteModelInterface.prototype.getNavigationInfo = function () {
  return _.cloneDeep(this._model.navigation);
};

RemoteModelInterface.prototype.getFullDataWithOverrides = function (compId) {
  return _.defaults(this.getData(compId), getFullData.call(this, compId));
};

RemoteModelInterface.prototype.getSiteMemberData = function () {
  return _.cloneDeep(this._model.siteMemberData);
};

RemoteModelInterface.prototype.getSessionInfo = function () {
  return _.cloneDeep(this._model.sessionInfo);
};

//Setters

RemoteModelInterface.prototype.setDataWithoutUpdate = function (compId, partialData) {
  set.call(this, compId, DATA, partialData);
};

RemoteModelInterface.prototype.setData = function (compId, partialData) {
  set.call(this, compId, DATA, partialData, this._onUpdateCallback);
};

RemoteModelInterface.prototype.setStyle = function (compId, partialData) {
  set.call(this, compId, STYLE, partialData, this._onUpdateCallback);
};

RemoteModelInterface.prototype.setDesign = function (compId, partialData) {
  set.call(this, compId, DESIGN, partialData, this._onUpdateCallback);
};

RemoteModelInterface.prototype.setProps = function (compId, partialProps, cb) {
  set.call(this, compId, PROPS, partialProps, function (cid, property, partial) {
    this._onUpdateCallback.call(this, cid, property, partial, cb);
  }.bind(this));
};

RemoteModelInterface.prototype.setLayout = function (compId, partialLayout) {
  set.call(this, compId, LAYOUT, partialLayout, this._onUpdateCallback);
};

RemoteModelInterface.prototype.setPublicAPI = function (compId, api) {
  var comp = _.get(this._model.components, compId);
  if (comp) {
    comp[PUBLIC_API] = api;
  }
};

RemoteModelInterface.prototype.getCurrentScope = function () {
  return _.clone(_.get(this._model.scopesHierarchy, 0));
};

function getFullData(compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, FULL_DATA]));
}

function executeBehavior(behaviorType, behaviorName, params, compId, callback) {
  var behavior = {
    type: behaviorType,
    name: behaviorName,
    targetId: compId,
    params: params
  };

  if (this._onUpdateCallback) {
    this._onUpdateCallback(compId, BEHAVIOR, behavior, callback);
  }
}

RemoteModelInterface.prototype.executeCompBehavior = function (compId, behaviorName, params, callback) {
  executeBehavior.call(this, 'comp', behaviorName, params, compId, callback);
};

RemoteModelInterface.prototype.executeAnimation = function (compId, animationName, params, callback) {
  executeBehavior.call(this, 'animation', animationName, params, compId, callback);
};

RemoteModelInterface.prototype.setUpdateCallback = function (onUpdateCallback) {
  this._onUpdateCallback = onUpdateCallback;
};

RemoteModelInterface.prototype.registerEvent = function (contextId, compId, eventType, controllerId, callback) {
  var callbackId = void 0;
  if (callback === undefined) {
    //TODO - backward compatibility - remove after SDK next release
    callback = controllerId;
    controllerId = undefined;
  }
  if (_.isFunction(callback)) {
    callbackId = guid();
    this._model.eventHandlers[callbackId] = { callback: callback, contextId: contextId, controllerId: controllerId };
  } else {
    callbackId = callback;
  }
  var eventDescriptor = {
    contextId: contextId,
    eventType: eventType,
    callbackId: callbackId
  };
  var component = _.get(this._model, ['components', compId]);
  if (component !== undefined) {
    this._hooksManager.executeHooksAndUpdateValue(this, 'registerEvent', component.type, compId, [contextId, eventType, controllerId, callback]);
    component.events.push({ eventType: eventType, callbackId: callbackId });
    if (this._transaction._onTransaction) {
      addItemToTransactionQueue.call(this, compId, 'registerEvent', eventDescriptor);
      return;
    }
    if (_.isFunction(this._onUpdateCallback)) {
      this._onUpdateCallback(compId, 'registerEvent', eventDescriptor);
    }
  }
};

RemoteModelInterface.prototype.toJson = function () {
  return this._model;
};

//General

RemoteModelInterface.prototype.getComponents = function () {
  var templateComponents = {};
  for (var compId in this._model.components) {
    //eslint-disable-line guard-for-in
    if (!modelUtils.isTemplateComp(this._model, compId)) {
      templateComponents[compId] = this.getComp(compId);
    }
  }

  return templateComponents;
};

RemoteModelInterface.prototype.getScopedRMI = function (controllerId) {
  var scopedRMI = new this.constructor(this._model, this._onUpdateCallback, { _hooksManager: this._hooksManager, _transaction: this._transaction });
  scopedRMI.getCompIdsFromRole = scopedRMI.getCompIdsFromRole.bind(scopedRMI, controllerId);
  scopedRMI.getCompIdsFromType = scopedRMI.getCompIdsFromType.bind(scopedRMI, controllerId);
  scopedRMI.getConfig = scopedRMI.getConfig.bind(scopedRMI, controllerId);

  return scopedRMI;
};

RemoteModelInterface.prototype.getNestedScopedRMI = function (model) {
  return new this.constructor(model || this._model, this._onUpdateCallback, { _hooksManager: this._hooksManager, _transaction: this._transaction });
};

RemoteModelInterface.prototype.getCompIdsFromType = function (controllerId, type, onlyNested) {
  var components = _.get(this._model.connections, controllerId);
  var compIds = _.flatMap(components, Object.keys);
  var comps = [];
  var acceptedScopes = getCurrentScopeId.call(this, onlyNested);

  compIds.forEach(function (compId) {
    var compType = this.getType(compId);
    if (compType === type && acceptedScopes.includes(_.get(this._model.componentsScopes, compId))) {
      comps.push(compId);
    }
  }, this);
  return comps;
};

RemoteModelInterface.prototype.getCompIdsFromRole = function (controllerId, role, onlyNested) {
  var _this2 = this;

  var connectionConfigs = _.get(this._model.connections, [controllerId, role]);
  var acceptedScopes = getCurrentScopeId.call(this, onlyNested);
  var compIds = connectionConfigs ? Object.keys(connectionConfigs) : [];
  return compIds.filter(function (compId) {
    return acceptedScopes.includes(_.get(_this2._model.componentsScopes, compId));
  });
};

RemoteModelInterface.prototype.getConfig = function (controllerId, compId, role, onlyNested) {
  var connectionConfigs = _.get(this._model.connections, [controllerId, role]);
  var acceptedScopes = getCurrentScopeId.call(this, onlyNested);

  return connectionConfigs && connectionConfigs.hasOwnProperty(compId) && acceptedScopes.includes(_.get(this._model.componentsScopes, compId)) ? connectionConfigs[compId] : {};
};

RemoteModelInterface.prototype.updateModel = function (modelUpdates) {
  for (var compId in modelUpdates) {
    //eslint-disable-line guard-for-in
    var defaultComp = generateDefaultCompStructure();
    var comp = _.get(this._model.components, compId);
    var compUpdates = modelUpdates[compId];
    if (!comp) {
      continue;
    }

    for (var keyToUpdate in compUpdates) {
      if (!_.has(comp, keyToUpdate)) {
        continue;
      }
      if (_.isObject(comp[keyToUpdate])) {
        if (compUpdates[keyToUpdate]) {
          _.assign(comp[keyToUpdate], compUpdates[keyToUpdate]);
        } else {
          // for modes change, when key should be initial to default value
          comp[keyToUpdate] = defaultComp[keyToUpdate];
        }
      } else {
        comp[keyToUpdate] = compUpdates[keyToUpdate];
      }
    }
  }
};

RemoteModelInterface.prototype.getScopedRMIByCompId = function (compId) {
  var itemContext = this.getRepeaterItemContext(compId);
  if (_.isEmpty(itemContext)) {
    return this;
  }

  var displayedRoot = itemContext.displayedRoot,
      itemId = itemContext.itemId;


  return this.getScopedRMIForRepeaterItem(displayedRoot, itemId);
};

RemoteModelInterface.prototype.getScopedRMIForRepeaterItem = function (repeaterId, itemId) {
  var model = _.clone(this._model);
  var templateCompIds = modelUtils.getAllCompsUnderRoot(model, repeaterId);
  var itemCompIds = templateCompIds.map(function (compId) {
    return repeaterUtils.structure.getUniqueDisplayedId(compId, itemId);
  });

  model.scopesHierarchy = _.clone(model.scopesHierarchy);
  model.scopesHierarchy.unshift({ type: COMPONENT_SCOPE, id: repeaterId, compId: repeaterId, additionalData: { itemId: itemId } });

  model.componentsScopes = _.clone(model.componentsScopes);
  templateCompIds.forEach(function (templateCompId) {
    return model.componentsScopes[templateCompId] = null;
  });
  itemCompIds.forEach(function (itemCompId) {
    return model.componentsScopes[itemCompId] = repeaterId;
  });

  return this.getNestedScopedRMI(model);
};

RemoteModelInterface.prototype.getRepeaterItemContext = function (compId) {
  var displayedRoot = _.get(this._model.components, [compId, DISPLAYED_ROOT]);

  if (!displayedRoot) {
    return {};
  }

  var itemId = repeaterUtils.structure.getItemId(compId);
  return { displayedRoot: displayedRoot, itemId: itemId };
};

RemoteModelInterface.prototype.startTransaction = function () {
  this._transaction._onTransaction = true;
};

RemoteModelInterface.prototype.endTransaction = function () {
  if (this._onUpdateCallback) {
    this._onUpdateCallback(null, 'executeBatch', this._transaction._transactionData);
  }
  this._transaction._onTransaction = false;
  this._transaction._transactionData = {};
};

RemoteModelInterface.prototype.setBatchData = function (newData) {
  _.forEach(newData, function (dataByProperty, compId) {
    _.forEach(dataByProperty, function (partialData, propertyType) {
      switch (propertyType) {
        case 'registerEvent':
          _.forEach(partialData, function (eventDescriptor) {
            this.registerEvent.call(this, eventDescriptor.contextId, compId, eventDescriptor.eventType, eventDescriptor.controllerId, eventDescriptor.callbackId);
          }.bind(this));
          break;
        default:
          var funcName = 'set' + _.startCase(propertyType);
          this[funcName].call(this, compId, partialData);
          break;
      }
    }.bind(this));
  }.bind(this));
};

RemoteModelInterface.prototype.registerHook = function (hookName, compType, callback) {
  this._hooksManager.registerHook(hookName, compType, callback);
};

RemoteModelInterface.prototype.getHooks = function () {
  return this._hooksManager.HOOKS;
};

//Utility

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function set(compId, property, partial, onUpdateCallback) {
  var comp = _.get(this._model, ['components', compId]);
  if (!comp) {
    return;
  }

  this._hooksManager.executeHooksAndUpdateValue(this, property, comp.type, compId, [partial, onUpdateCallback]);
  if (comp[IS_DISPLAYED]) {
    this._model.components[compId][property] = _.defaults({}, partial, comp[property]);
  }
  if (onUpdateCallback) {
    if (this._transaction._onTransaction) {
      addItemToTransactionQueue.call(this, compId, property, partial);
    } else {
      onUpdateCallback(compId, property, partial);
    }
  }
}

function addItemToTransactionQueue(compId, property, partial) {
  var transactionData = this._transaction._transactionData;
  if (!transactionData[compId]) {
    transactionData[compId] = {};
  }

  if (property === 'registerEvent') {
    if (!transactionData[compId][property]) {
      transactionData[compId][property] = [];
    }
    transactionData[compId][property].push(partial);
    return;
  }
  if (!transactionData[compId][property]) {
    transactionData[compId][property] = {};
  }
  _.assign(transactionData[compId][property], partial);
}

module.exports = RemoteModelInterface;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var externalRegx = /^(http|https):\/\/(.*)/;
var mailtoRegx = /^mailto:([^\?]*)(?:\?subject=(.*)?)?/;
var pageRegx = /^\/([^ \?]*)[\?]?(.*)/;
var pageTopRegx = /^(\/?)([^ \?]*)#(top|SCROLL_TO_TOP)[\?]?(.*)/;
var pageBottomRegx = /^(\/?)([^ \?]*)#(bottom|SCROLL_TO_BOTTOM)[\?]?(.*)/;
var oldDocumentFormatRegx = /^document:\/\/(.*)/;
var newDocumentFormatRegx = /^wix:document:\/\/v1\/(.+)\/(.+)/;
var phoneRegx = /^tel:(.*)/;
var pageWithAnchor = /^\/([^ \?]*)#([^ \?]*)[\?]?(.*)/;
var samePageWithAnchor = /^#([^ \?]*)[\?]?(.*)/;
var ANCHOR_TYPE_TO_NAME = {
  SCROLL_TO_TOP: 'top',
  SCROLL_TO_BOTTOM: 'bottom'
};
var LinkType = {
  PAGE: 'PageLink',
  DYNAMIC_PAGE: 'DynamicPageLink',
  DYNAMIC_PAGE_WITH_QUERY_PARAMS: 'DynamicPageLinkWithQueryParams',
  EXTERNAL: 'ExternalLink',
  EMAIL: 'EmailLink',
  DOCUMENT: 'DocumentLink',
  PHONE: 'PhoneLink',
  PAGE_TOP: 'AnchorLink',
  PAGE_BOTTOM: 'AnchorLink',
  SAME_PAGE_ANCHOR_LINK: 'SamePageAnchorLink',
  ANCHOR: 'AnchorLink'
};

var SUPPORTED_TARGETS = ['_blank', '_self'];

var MASTER_PAGE_ID = 'masterPage';

var anchorLinkBaseTemplate = _.template('<%=linkObject.pageId%>#<%=linkObject.anchorDataId%>', { variable: 'linkObject' });
var pageLinkBaseTemplate = _.template('/<%=linkObject.pageId%>', { variable: 'linkObject' });

function getInnerRoute(parts, hasAnchor, hasQueryParams) {
  var partsWithoutQueryParams = parts;
  if (hasQueryParams) {
    partsWithoutQueryParams = _.dropRight(parts);
  }
  var partsWithoutPrefixAndSuffix = _.drop(hasAnchor ? _.dropRight(partsWithoutQueryParams) : partsWithoutQueryParams);
  return _.join(partsWithoutPrefixAndSuffix, '/');
}

var LINK_URL_TEMPLATES = {
  PageLink: {
    url: getPageLinkTemplate, link: function link(type, parts, siteStructurePrefixes, siteStructurePages) {
      var pageLinkObj = {
        type: type,
        pageId: '#' + translateUriSeoToPageId(parts[1], siteStructurePages)

      };
      if (parts.length === 3 && parts[2]) {
        _.assign(pageLinkObj, { queryParams: convertQueryParamsToObject(parts[2]) || '' });
      }
      return pageLinkObj;
    },
    regex: [pageRegx]
  },
  DocumentLink: {
    url: _.template('wix:document://v1/<%=linkObject.docId%>/<%=linkObject.name%>', { variable: 'linkObject' }), link: function link(type, parts) {
      return {
        type: type,
        docId: parts[1],
        name: _.isUndefined(parts[2]) ? '' : parts[2]
      };
    },
    regex: [oldDocumentFormatRegx, newDocumentFormatRegx]
  },
  PhoneLink: {
    url: _.template('tel:<%=linkObject.phoneNumber%>', { variable: 'linkObject' }), link: function link(type, parts) {
      return {
        type: type,
        phoneNumber: parts[1]
      };
    },
    regex: [phoneRegx]
  },
  EmailLink: {
    url: getEmailLinkTemplate,
    link: function link(type, parts) {
      var data = {
        type: type,
        recipient: _.escape(parts[1])
      };
      if (parts[2]) {
        data.subject = _.escape(parts[2]);
      }
      return data;
    },

    regex: [mailtoRegx]
  },
  ExternalLink: {
    url: _.template('<%=linkObject.url%>', { variable: 'linkObject' }), link: function link(type, parts, siteStructurePrefixes, siteStructurePages, target) {
      if (target && !_.includes(SUPPORTED_TARGETS, target)) {
        throw new Error('Unsupported target value');
      }
      return {
        type: type,
        url: _.template('<%= partA %>://<%= partB%>')({ partA: parts[1], partB: parts[2] }),
        target: target || '_blank'
      };
    },
    regex: [externalRegx]
  },
  DynamicPageLink: {
    url: getDynamicPageLinkTemplate, link: function link(type, parts, siteStructurePrefixes) {
      var hasAnchor = _.startsWith(_.last(parts), '#');
      var routerData = _.find(siteStructurePrefixes, { name: parts[0] });
      var data = {
        type: type,
        innerRoute: getInnerRoute(parts, hasAnchor) || '/',
        routerId: routerData.id
      };
      if (hasAnchor) {
        var anchorName = _.last(parts).replace('#', '');
        data.anchorDataId = _.get(_.invert(ANCHOR_TYPE_TO_NAME), anchorName, anchorName);
      }
      return data;
    },
    regex: [pageTopRegx, pageBottomRegx, pageWithAnchor, pageRegx]
  },
  DynamicPageLinkWithQueryParams: {
    url: getDynamicPageLinkTemplate, link: function link(type, parts, siteStructurePrefixes) {
      var queryParams = _.last(parts);
      var hasAnchor = _.startsWith(parts[parts.length - 2], '#');
      var routerData = _.find(siteStructurePrefixes, { name: parts[0] });
      var data = {
        type: LinkType.DYNAMIC_PAGE,
        innerRoute: getInnerRoute(parts, hasAnchor, true) || '/',
        routerId: routerData.id,
        queryParams: convertQueryParamsToObject(queryParams)

      };
      if (hasAnchor) {
        var anchorName = parts[parts.length - 2].replace('#', '');
        data.anchorDataId = _.get(_.invert(ANCHOR_TYPE_TO_NAME), anchorName, anchorName);
      }
      return data;
    },
    regex: [pageTopRegx, pageBottomRegx, pageWithAnchor, pageRegx]
  },
  AnchorLink: {
    url: getAnchorLinkTemplate, link: function link(type, parts, siteStructurePrefixes, pages) {
      var anchorDataId = parts[2];
      var anchorLinkObj = {
        type: type,
        pageId: '#' + translateUriSeoToPageId(parts[1], pages),
        anchorDataId: _.invert(ANCHOR_TYPE_TO_NAME)[anchorDataId] || anchorDataId
      };
      if (parts.length === 4 && parts[3]) {
        _.assign(anchorLinkObj, { queryParams: convertQueryParamsToObject(parts[3]) });
      }
      return anchorLinkObj;
    },
    regex: [pageWithAnchor]
  },
  SamePageAnchorLink: {
    url: getAnchorLinkTemplate, link: function link(type, parts) {
      var anchorDataId = parts[1];
      var samePageAnchorLinkObj = {
        type: LinkType.ANCHOR,
        anchorDataId: _.invert(ANCHOR_TYPE_TO_NAME)[anchorDataId] || anchorDataId,
        pageId: '#' + MASTER_PAGE_ID
      };
      if (parts.length === 3 && parts[2]) {
        _.assign(samePageAnchorLinkObj, { queryParams: convertQueryParamsToObject(parts[2]) });
      }
      return samePageAnchorLinkObj;
    },
    regex: [samePageWithAnchor]
  }
};

function getUrlParts(regExpArr, value, type) {
  if (type === LinkType.DYNAMIC_PAGE || type === LinkType.DYNAMIC_PAGE_WITH_QUERY_PARAMS) {
    return getDynamicPageParts(value);
  }
  var regexp = _.find(regExpArr, function (regExpItem) {
    return regExpItem.test(value);
  });
  var parts = value.match(regexp);
  parts = parts ? parts : [];
  return parts;
}

function getDynamicPageParts(str) {
  var pageRegRes = str.match(pageRegx);
  var parts = pageRegRes[1].replace('#', '/#').split(/[\/]+/);
  var hasQueryParam = _.includes(str, '?');
  if (hasQueryParam) {
    parts.push(_.last(pageRegRes));
  }
  return parts;
}

function getAnchorName(anchorDataId) {
  return ANCHOR_TYPE_TO_NAME[anchorDataId] || anchorDataId;
}

function getDynamicPagePrefix(siteStructurePrefixes, linkObject) {
  var routerConfig = _.find(siteStructurePrefixes, { id: linkObject.routerId });
  return routerConfig && routerConfig.prefix;
}

function getDynamicPageLinkTemplate(linkObject, siteStructurePrefixes) {
  var dynamicPageSuffix = !linkObject.innerRoute || linkObject.innerRoute === '/' ? '' : '/' + linkObject.innerRoute;
  var route = getDynamicPagePrefix(siteStructurePrefixes, linkObject) + dynamicPageSuffix;

  var anchorDataId = getAnchorName(linkObject.anchorDataId);
  var customLinkObject = {
    pageId: _.startsWith(route, '/') ? route : '/' + route,
    anchorDataId: anchorDataId
  };
  return customLinkObject.anchorDataId ? anchorLinkBaseTemplate(customLinkObject) : route;
}

function getPageLinkTemplate(linkObject, siteStructurePrefixes, siteStructurePages) {
  var pageId = getPageIdForURL(linkObject.pageId);
  var pageObj = _.find(siteStructurePages, { id: pageId });
  return pageObj ? pageObj.url : pageLinkBaseTemplate({ pageId: pageId });
}

function getEmailLinkTemplate(linkObject) {
  var templateString = 'mailto:<%=linkObject.recipient%>';
  if (_.has(linkObject, 'subject')) {
    templateString += '?subject=<%=linkObject.subject%>';
  }

  return _.template(templateString, { variable: 'linkObject' })(linkObject);
}

function getAnchorLinkTemplate(linkObject, siteStructurePrefixes, siteStructurePages) {
  var anchorName = getAnchorName(linkObject.anchorDataId);
  if (isMasterPage(extractPageId(linkObject.pageId))) {
    return '#' + anchorName;
  }

  var pageId = getPageIdForURL(linkObject.pageId);
  var pageObj = _.find(siteStructurePages, { id: pageId });
  return pageObj ? anchorLinkBaseTemplate({
    pageId: pageObj.url,
    anchorDataId: anchorName
  }) : anchorLinkBaseTemplate({
    pageId: _.startsWith(pageId, '/') ? pageId : '/' + pageId,
    anchorDataId: anchorName
  });
}

function getPageIdForURL(pageId) {
  pageId = extractPageId(pageId);
  if (isMasterPage(pageId)) {
    return '';
  }

  return pageId.replace('#', '');
}

function extractPageId(pageId) {
  if (!pageId) {
    return pageId;
  }

  if (_.isPlainObject(pageId)) {
    if (pageId.pageUriSEO) {
      return pageId.pageUriSEO;
    } else if (isMasterPage(pageId.id)) {
      return MASTER_PAGE_ID;
    }

    throw new Error('pageId object should contain pageUriSEO');
  }

  return pageId;
}

function translateUriSeoToPageId(uriSeo, siteStructurePages) {
  var isHomePage = uriSeo === '';
  var pageData = isHomePage ? _.find(siteStructurePages, 'isMainPage') : _.find(siteStructurePages, { url: '/' + uriSeo });
  return _.get(pageData, 'id', uriSeo);
}

function isDynamicPage(urlParts, siteStructurePrefixes) {
  return _.find(siteStructurePrefixes, { name: urlParts[0] });
}

function getDynamicPageType(str) {
  return _.includes(str, '?') ? LinkType.DYNAMIC_PAGE_WITH_QUERY_PARAMS : LinkType.DYNAMIC_PAGE;
}

function isMasterPage(pageId) {
  return pageId.replace('#', '') === MASTER_PAGE_ID;
}

function getLinkType(str, siteStructurePrefixes) {
  switch (true) {
    case externalRegx.test(str):
      return LinkType.EXTERNAL;
    case mailtoRegx.test(str):
      return LinkType.EMAIL;
    case samePageWithAnchor.test(str):
      return LinkType.SAME_PAGE_ANCHOR_LINK;
    case pageTopRegx.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.PAGE_TOP;
    case pageBottomRegx.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.PAGE_BOTTOM;
    case pageWithAnchor.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.ANCHOR;
    case pageRegx.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.PAGE;
    case oldDocumentFormatRegx.test(str):
      return LinkType.DOCUMENT;
    case newDocumentFormatRegx.test(str):
      return LinkType.DOCUMENT;
    case phoneRegx.test(str):
      return LinkType.PHONE;
    default:
      throw new Error('Unsupported link type');
  }
}

function convertLinkObjectToUrl(siteStructurePrefixes, linkObject, siteStructurePages) {
  if (!linkObject || !_.get(LINK_URL_TEMPLATES, [linkObject.type, 'url'])) {
    throw new Error('Provided link type is not supported');
  }
  var urlTemplate = _.get(LINK_URL_TEMPLATES, [linkObject.type, 'url']);
  return urlTemplate(linkObject, siteStructurePrefixes, siteStructurePages);
}

function convertUrlToLinkObject(siteStructurePrefixes, url, target, siteStructurePages) {
  var type = getLinkType(url, siteStructurePrefixes);
  var urlParts = getUrlParts(LINK_URL_TEMPLATES[type].regex, url, type);
  var linkTemplate = _.get(LINK_URL_TEMPLATES, [type, 'link']);
  return linkTemplate(type, urlParts, siteStructurePrefixes, siteStructurePages, target);
}

function getAnchorDataId(linkItem) {
  return getAnchorName(linkItem.anchorDataId);
}

function getPageId(linkItem) {
  return extractPageId(linkItem.pageId);
}

function convertQueryParamsToObject(query) {
  if (!_.isString(query)) {
    return {};
  }
  var queryStringArray = query.split('&');
  return _.reduce(queryStringArray, function (res, queryParam) {
    var splitedQueryParam = queryParam.split("=");
    res[splitedQueryParam[0]] = splitedQueryParam[1] ? decodeURIComponent(splitedQueryParam[1]) : null;
    return res;
  }, {});
};

module.exports = {
  convertLinkObjectToUrl: convertLinkObjectToUrl,
  convertUrlToLinkObject: convertUrlToLinkObject,
  getAnchorDataId: getAnchorDataId,
  getPageId: getPageId,
  convertQueryParamsToObject: convertQueryParamsToObject
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var styleMap = {
  p: 'font_8',
  h1: 'font_0',
  h2: 'font_2',
  h3: 'font_3',
  h4: 'font_4',
  h5: 'font_5',
  h6: 'font_6',
  ol: 'font_8',
  ul: 'font_8'
};

function applyTextStyles() {
  var htmlString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!htmlString) {
    return htmlString;
  }
  var regexp = /<(ol|ul|h[1-6]|p)(.*?)>/g;
  var classRegexp = /class\s*?=\s*["'](.*?)['"]/;
  var g2ClassRegexp = /(class\s*?=\s*["'])(.*?)(['"])/;
  return htmlString.replace(regexp, function (match, g1, g2) {
    var matchedClassArray = g2.match(classRegexp);
    if (!matchedClassArray) {
      return '<' + g1 + g2 + ' class="' + styleMap[g1] + '">';
    }
    var matchedClass = matchedClassArray[1];
    if (/(^|\s)font_[0-9]($|\s)/.test(matchedClass)) {
      return match;
    } else if (g1 === 'p' && /\bp[13]\b/i.test(matchedClass)) {
      return match.replace(/(.*?\bclass\s*?=.*?)\bp([13])\b(.*)/, function (match, _g1, _g2, g3) {
        var _class = _g2 === '1' ? 'font_7' : 'font_9';
        return '' + _g1 + _class + g3;
      });
    }

    return '<' + g1 + g2.replace(g2ClassRegexp, function (_match, _g1, _g2, _g3) {
      return '' + _g1 + styleMap[g1] + ' ' + _g2 + _g3;
    }) + '>';
  });
}

function applyTransformationForSetHtml(value) {
  value = applyTextStyles(value);
  return value;
}

function applyTransformationForGetHtml() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var startBlockRegexp = /<(ol|ul|h[1-6]|p)(.*?)>/g;
  var p1p2regexp = /(class\s*=['"][^'"]*?)\bfont_([79])\b/;
  return data.replace(startBlockRegexp, function (match, tag) {
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    var defaultClass = styleMap[tag];
    var defaultClassForTagRegexp = new RegExp('(class\\s*=[\'"].*?)' + defaultClass);
    if (defaultClassForTagRegexp.test(attributes)) {
      match = match.replace(defaultClassForTagRegexp, '$1');
    } else if (tag === 'p' && p1p2regexp.test(attributes)) {
      match = match.replace(p1p2regexp, function (match, prefix, p1p2) {
        return '' + prefix + (p1p2 === '7' ? 'p1' : 'p3');
      });
    }
    return match.replace(/class\s*=(['"])\s*\1/, '') //remove empty class attribute
    .replace(/class\s*=(['"])\s*(.*?)\s*\1/, function (_match, quote, classes) {
      return 'class=' + quote + classes + quote;
    }).replace(/(.+)\s{2,}/g, '$1 ') //remove pointless additional spaces e.g:class="a      b"
    .replace(/\s+>/, '>'); //remove pointless space from before closing tag
  });
}
module.exports = {
  applyTransformationForSetHtml: applyTransformationForSetHtml,
  applyTransformationForGetHtml: applyTransformationForGetHtml
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sdkTypeByViewerType = {
  'wysiwyg.viewer.components.SiteButton': 'Button',
  'wysiwyg.viewer.components.PopupCloseTextButton': 'Button',
  'wysiwyg.viewer.components.PopupCloseIconButton': 'Button',
  'wysiwyg.common.components.imagebutton.viewer.ImageButton': 'Button',
  'wysiwyg.viewer.components.WPhoto': 'Image',
  'wysiwyg.viewer.components.FooterContainer': 'Footer',
  'wysiwyg.viewer.components.HeaderContainer': 'Header',
  'wysiwyg.viewer.components.WRichText': 'Text',
  'mobile.core.components.Page': 'Page',
  'wysiwyg.viewer.components.inputs.TextInput': 'TextInput',
  'wysiwyg.viewer.components.inputs.TextAreaInput': 'TextBox',
  'wysiwyg.viewer.components.inputs.DatePicker': 'DatePicker',
  'wysiwyg.viewer.components.BoxSlideShow': 'Slideshow',
  'wysiwyg.viewer.components.StripContainerSlideShow': 'Slideshow',
  'wysiwyg.viewer.components.SlideShowGallery': 'Gallery',
  'wysiwyg.viewer.components.SliderGallery': 'Gallery',
  'wysiwyg.viewer.components.MatrixGallery': 'Gallery',
  'wysiwyg.viewer.components.PaginatedGridGallery': 'Gallery',
  'mobile.core.components.Container': 'Box',
  'wysiwyg.viewer.components.Group': 'Box',
  'platform.components.AppController': 'AppController',
  'wysiwyg.viewer.components.svgshape.SvgShape': 'Shape',
  'wysiwyg.viewer.components.inputs.Checkbox': 'Checkbox',
  'wysiwyg.viewer.components.inputs.RadioGroup': 'RadioButtonGroup',
  'wysiwyg.viewer.components.BoxSlideShowSlide': 'Slide',
  'wysiwyg.viewer.components.StripContainerSlideShowSlide': 'Slide',
  'wysiwyg.viewer.components.inputs.ComboBoxInput': 'Dropdown',
  'wysiwyg.viewer.components.Column': 'Column',
  'wysiwyg.viewer.components.StripColumnsContainer': 'ColumnStrip',
  'wysiwyg.viewer.components.Grid': 'Table',
  'wysiwyg.viewer.components.inputs.FileUploader': 'UploadButton',
  'wysiwyg.common.components.anchor.viewer.Anchor': 'Anchor',
  'wysiwyg.viewer.components.tpapps.TPASection': 'IFrame',
  'wysiwyg.viewer.components.tpapps.TPAMultiSection': 'IFrame',
  'wysiwyg.viewer.components.tpapps.TPAGluedWidget': 'IFrame',
  'wysiwyg.viewer.components.HtmlComponent': 'HtmlComponent',
  'wysiwyg.viewer.components.GoogleMap': 'GoogleMap',
  'wysiwyg.viewer.components.Video': 'Video',
  'wysiwyg.viewer.components.HoverBox': 'HoverBox',
  'tpa.viewer.components.Freestyle': 'Gallery',
  'tpa.viewer.components.Honeycomb': 'Gallery',
  'tpa.viewer.components.Accordion': 'Gallery',
  'wysiwyg.viewer.components.tpapps.TPA3DCarousel': 'Gallery',
  'wysiwyg.viewer.components.tpapps.TPA3DGallery': 'Gallery',
  'tpa.viewer.components.Impress': 'Gallery',
  'tpa.viewer.components.Masonry': 'Gallery',
  'tpa.viewer.components.Collage': 'Gallery',
  'tpa.viewer.components.StripSlideshow': 'Gallery',
  'tpa.viewer.components.StripShowcase': 'Gallery',
  'tpa.viewer.components.Thumbnails': 'Gallery',
  'wysiwyg.viewer.components.tpapps.TPAWidget': 'IFrame',
  'wysiwyg.common.components.verticalmenu.viewer.VerticalMenu': 'VerticalMenu',
  'wysiwyg.viewer.components.LoginSocialBar': 'AccountNavBar',
  'wysiwyg.viewer.components.Repeater': 'Repeater',
  'wysiwyg.viewer.components.MediaContainer': 'Container',
  'wysiwyg.viewer.components.mobile.TinyMenu': 'MobileMenu'
};

var sdkTypeByWidgetId = {
  '142bb34d-3439-576a-7118-683e690a1e0d': 'Gallery'
};

var defaultSdkType = 'HiddenCollapsedElement';

module.exports = {
  sdkTypeByViewerType: sdkTypeByViewerType,
  sdkTypeByWidgetId: sdkTypeByWidgetId,
  defaultSdkType: defaultSdkType
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(0);
var TPA_WIDGET_TYPE = 'wysiwyg.viewer.components.tpapps.TPAWidget';

var TypeUtils = function () {
  function TypeUtils(typesData) {
    _classCallCheck(this, TypeUtils);

    this._typesData = typesData;
  }

  _createClass(TypeUtils, [{
    key: 'getSdkType',
    value: function getSdkType(viewerType, tpaWidgetId) {
      var typesData = this._typesData;
      var sdkTypeByViewerType = typesData.sdkTypeByViewerType;
      var sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;
      var defaultSdkType = typesData.defaultSdkType;

      if (tpaWidgetId && viewerType !== TPA_WIDGET_TYPE) {
        throw new Error('tpaWidgetId is only supported with viewer type [' + TPA_WIDGET_TYPE + ']');
      }

      return sdkTypeByWidgetId[tpaWidgetId] || sdkTypeByViewerType[viewerType] || defaultSdkType;
    }
  }, {
    key: 'getFullSdkType',
    value: function getFullSdkType(viewerType, tpaWidgetId) {
      return '$w.' + this.getSdkType(viewerType, tpaWidgetId);
    }
  }, {
    key: 'getPotentialViewerTypes',
    value: function getPotentialViewerTypes(sdkType) {
      var typesData = this._typesData;
      var sdkTypeByViewerType = typesData.sdkTypeByViewerType;
      var sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;

      var types = _.keys(sdkTypeByViewerType);
      var resultViewerTypes = types.filter(function (viewerType) {
        return sdkTypeByViewerType[viewerType] === sdkType;
      });
      var isPotentiallyTPA = _.includes(_.values(sdkTypeByWidgetId), sdkType);
      if (isPotentiallyTPA) {
        resultViewerTypes.push('wysiwyg.viewer.components.tpapps.TPAWidget');
      }
      return resultViewerTypes;
    }
  }, {
    key: 'Types',
    get: function get() {
      var typesData = this._typesData;
      var sdkTypeByViewerType = typesData.sdkTypeByViewerType;
      var sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;

      var allSdkTypes = _.uniq(_.values(sdkTypeByViewerType).concat(_.values(sdkTypeByWidgetId)));
      return _.zipObject(allSdkTypes, allSdkTypes);
    }
  }, {
    key: 'defaultSdkType',
    get: function get() {
      var typesData = this._typesData;
      return typesData.defaultSdkType;
    }
  }]);

  return TypeUtils;
}();

module.exports = TypeUtils;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ = __webpack_require__(0);
var IMAGE_URI = 'image://';
var DOC_URI = 'wix:document://';
var VERSION = 'v1';
var wixCodeImgUriTemplate = _.template(IMAGE_URI + VERSION + '/${uri}/${width}_${height}/${title}');
var wixCodeDocUriTemplate = _.template(DOC_URI + VERSION + '/${uri}/${filename}');
var MEDIA_SRC_REGEX = /^image:\/\/(.*)\/(.*)\/(.*)_(.*)\/(.*)/;

function generateWixCodeImageUri(imageData) {
  return wixCodeImgUriTemplate(imageData);
}

function generateWixCodeDocumentUri(documentData) {
  return wixCodeDocUriTemplate(documentData);
}

function removeEmptyValues(res, v, k) {
  if (v) {
    res[k] = v;
  }
  return res;
}

function extractImageRelativeUriFromWixUri(wixCodeImageUri) {
  if (MEDIA_SRC_REGEX.test(wixCodeImageUri)) {
    var _ref = wixCodeImageUri.match(MEDIA_SRC_REGEX) || [0, 0, wixCodeImageUri],
        _ref2 = _slicedToArray(_ref, 3),
        baseSrc = _ref2[2];

    return baseSrc;
  }

  return wixCodeImageUri;
}

function extractImageDataFromWixUri(wixCodeImageUri) {
  if (MEDIA_SRC_REGEX.test(wixCodeImageUri)) {
    var _ref3 = wixCodeImageUri.match(MEDIA_SRC_REGEX) || [0, 0, wixCodeImageUri],
        _ref4 = _slicedToArray(_ref3, 6),
        uri = _ref4[2],
        width = _ref4[3],
        height = _ref4[4],
        title = _ref4[5];

    return _.reduce({ uri: uri, width: width, height: height, title: title }, removeEmptyValues, {});
  }

  return { uri: wixCodeImageUri };
}

module.exports = {
  generateWixCodeImageUri: generateWixCodeImageUri,
  generateWixCodeDocumentUri: generateWixCodeDocumentUri,
  extractImageRelativeUriFromWixUri: extractImageRelativeUriFromWixUri,
  extractImageDataFromWixUri: extractImageDataFromWixUri
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var repeaterUtils = __webpack_require__(1);
var modelUtils = __webpack_require__(9);

function cloneConnections(model, templateCompIds, itemIds) {
  var connections = _.get(model, 'connections');
  var contexts = _.keys(connections);
  _.forEach(contexts, function (context) {

    var roles = _.keys(_.get(connections, context));
    _.forEach(roles, function (role) {

      var compIds = _.keys(_.get(connections, [context, role]));
      _.forEach(compIds, function (compId) {
        if (_.includes(templateCompIds, compId)) {
          var templateConfig = _.get(connections, [context, role, compId]);

          _.forEach(itemIds, function (itemId) {
            var displayedItemId = repeaterUtils.structure.getUniqueDisplayedId(compId, itemId);
            _.set(connections, [context, role, displayedItemId], _.cloneDeep(templateConfig));
          });
        }
      });
    });
  });
}

function updateCompsScope(model, templateCompIds, itemIds) {
  _.forEach(templateCompIds, function (templateCompId) {
    _.forEach(itemIds, function (itemId) {
      var displayedItemId = repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      model['componentsScopes'][displayedItemId] = null;
    });
  });
}

function cloneComponents(model, templateCompIds, itemIds, repeaterId) {
  _.forEach(templateCompIds, function (templateCompId) {
    _.forEach(itemIds, function (itemId) {
      var newDisplayedCompId = repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      var templateData = model.components[templateCompId];
      var newDisplayedCompData = _.cloneDeep(templateData);
      newDisplayedCompData.displayedOnlyComponents = [];
      newDisplayedCompData.children = _.map(templateData.children, function (childId) {
        return repeaterUtils.structure.getUniqueDisplayedId(childId, itemId);
      });
      newDisplayedCompData.parent = templateData.parent === repeaterId ? repeaterId : repeaterUtils.structure.getUniqueDisplayedId(templateData.parent, itemId);
      newDisplayedCompData.displayedRoot = repeaterId;
      newDisplayedCompData.isDisplayed = !!_.get(model.components[repeaterId], 'isDisplayed');
      /*change data-item id for refs*/
      _.forEach(repeaterUtils.structure.SPLITTED_DATA_TYPES, function (dataType) {
        var compDataTypeValue = newDisplayedCompData[dataType];
        if (compDataTypeValue.id) {
          compDataTypeValue.id = repeaterUtils.structure.getUniqueDisplayedId(newDisplayedCompData[dataType].id, itemId);
          _.forEach(compDataTypeValue, function (val, key) {
            if (_.isObject(val) && val.id) {
              compDataTypeValue[key].id = repeaterUtils.structure.getUniqueDisplayedId(compDataTypeValue[key].id, itemId);
            }
          });
        }
      });

      model.components[newDisplayedCompId] = newDisplayedCompData;
    });
  });
}

function cloneComponentsAndConnections(model, templateCompIds, itemIds, repeaterId) {
  cloneConnections(model, templateCompIds, itemIds);
  cloneComponents(model, templateCompIds, itemIds, repeaterId);
  updateCompsScope(model, templateCompIds, itemIds);
}

function removeConnections(model, templateCompIds, itemIds) {
  var connections = _.get(model, 'connections');
  var contexts = _.keys(connections);

  _.forEach(contexts, function (context) {
    var roles = _.keys(_.get(connections, [context]));

    _.forEach(roles, function (role) {
      var compIds = _.keys(_.get(connections, [context, role]));

      _.forEach(compIds, function (compId) {
        var compItemId = repeaterUtils.structure.getItemId(compId);
        var compOriginalId = repeaterUtils.structure.getOriginalId(compId);

        if (compItemId && _.includes(itemIds, compItemId) && _.includes(templateCompIds, compOriginalId)) {
          delete connections[context][role][compId];
        }
      });
    });
  });
}

function removeCompsScope(model, templateCompIds, itemIds) {
  _.forEach(templateCompIds, function (templateCompId) {
    _.forEach(itemIds, function (itemId) {
      var displayedItemId = repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      delete model.componentsScopes[displayedItemId];
    });
  });
}

function removeComponents(model, templateCompIds, itemIds) {
  _.forEach(templateCompIds, function (templateCompId) {
    _.forEach(itemIds, function (itemId) {
      var displayedItemId = repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      delete model.components[displayedItemId];
    });
  });
}

function removeComponentsAndConnections(model, templateCompIds, itemIds) {
  removeConnections(model, templateCompIds, itemIds);
  removeCompsScope(model, templateCompIds, itemIds);
  removeComponents(model, templateCompIds, itemIds);
}

/*on repeater set items - creates displayed components and connections for added items and removes components and connections that are no loger in items*/
function updateRepeaterItems(RMI, hookName, repeaterId, partial) {
  if (partial.items) {
    var templateCompIds = modelUtils.getAllCompsUnderRoot(RMI._model, repeaterId);
    var repeaterData = _.get(RMI._model.components, [repeaterId, 'data']);
    var addedItems = repeaterUtils.items.getAddedItems(repeaterData.items, partial.items);
    cloneComponentsAndConnections(RMI._model, templateCompIds, _.map(addedItems, 'item._id'), repeaterId);

    var removedItems = repeaterUtils.items.getRemovedItems(repeaterData.items, partial.items);
    removeComponentsAndConnections(RMI._model, templateCompIds, _.map(removedItems, 'item._id'));
    _.forEach(templateCompIds, function (templateCompId) {
      var templateCompData = RMI._model.components[templateCompId];
      templateCompData.displayedOnlyComponents = _.map(partial.items, function (itemId) {
        return repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      });
    });
  }
}

/*Hook triggered on each set and check if the set is for template sync all existing item instances*/
function syncRepeaterItemData(RMI, hookName, compId) {
  var _arguments = arguments;

  var model = RMI._model;
  // set comp property to the template comp, since its isDisplayed property is always false
  if (hookName !== 'registerEvent' && modelUtils.isTemplateComp(model, compId)) {
    var comp = _.get(model, ['components', compId]);
    var partial = arguments[3];
    model.components[compId][hookName] = _.defaults({}, partial, comp[hookName]);
  }

  var displayedOnlyComponents = _.get(RMI._model.components, [compId, 'displayedOnlyComponents']);
  if (!_.isEmpty(displayedOnlyComponents)) {
    //is repeater template with displayed only comps
    var funcName = 'set' + _.startCase(hookName);
    if (hookName === 'registerEvent') {
      funcName = 'registerEvent';
      _.forEach(displayedOnlyComponents, function (itemId) {
        var args = [].concat(Array.prototype.slice.call(_arguments));
        RMI[funcName].apply(RMI, [args[3], itemId].concat(args.splice(4)));
      });
      return;
    }
    _.forEach(displayedOnlyComponents, function (itemId) {
      var args = [].concat(Array.prototype.slice.call(_arguments));
      if (hookName === 'data' && !_.isFunction(_.last(args))) {
        //if there is no callback should call setDataWithoutUpdate and not setData
        RMI.setDataWithoutUpdate.apply(RMI, [itemId].concat(args.splice(3)));
        return;
      }
      RMI[funcName].apply(RMI, [itemId].concat(args.splice(3)));
    });
  }
}

module.exports = {
  updateRepeaterItems: updateRepeaterItems,
  syncRepeaterItemData: syncRepeaterItemData
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(0);

var HOOKS = {
  all: 'all',
  data: 'data'
};

var ALL_COMPS_TYPE = '*';

var HooksManager = function () {
  function HooksManager() {
    _classCallCheck(this, HooksManager);

    this._hooks = {};
  }

  /**
   * Validate that the hook name is correct
   * @param {String} hookName - hooks name
   */


  _createClass(HooksManager, [{
    key: 'validateHookName',
    value: function validateHookName(hookName) {
      if (!HOOKS[hookName]) {
        throw "Invalid Hook Name " + hookName;
      }
    }

    /**
     * Unregister all hooks.
     */

  }, {
    key: 'unregisterAllHooks',
    value: function unregisterAllHooks() {
      this._hooks = {};
    }

    /**
     * Unregister only hooks that are passed
     * @param {Array} hooksToRemove - array of hooks names
     */

  }, {
    key: 'unregisterHooks',
    value: function unregisterHooks(hooksToRemove) {
      var _this = this;

      _.forEach(hooksToRemove, function (hookName) {
        return delete _this._hooks[hookName];
      });
    }

    /**
     * Execute all callbacks of the specified hook for the specified component. if registered to all will trigger this as well
     * @param {String} RMI
     * @param {String} hookName The name of the hook to execute (i.e HOOKS.DATA).
     * @param {String} compType The component type or none to  hooks that were registered for all component types.
     * @param {String} compId
     * @param {Array?} args The arguments that will be passed to the hook callbacks.
     */

  }, {
    key: 'executeHooksAndUpdateValue',
    value: function executeHooksAndUpdateValue(RMI, hookName, compType, compId, args) {
      function executeTypeHook(hooks) {
        var _this2 = this;

        if (!hooks) {
          return;
        }
        var hooksForCompType = hooks[compType] || [];
        var hooksForAllCompType = hooks['*'] || [];
        _.forEach(hooksForCompType.concat(hooksForAllCompType), function (cb) {
          cb.apply(_this2, [RMI, hookName, compId].concat(args || []));
        });
      }

      var hook = this._hooks[hookName];
      var allPropsHooks = this._hooks[HOOKS.all];
      executeTypeHook(hook);
      executeTypeHook(allPropsHooks);
    }

    /**
     * Register callback to run the function specified in when executing the hook specified in the hookName parameter according to the hook name
     * @param {String} hookName The name of the hook to registered
     * Hook name can be specific prop or all for all props
     * @param {String?} compType The component type that will use the callback while running the operation according to the hookType. if no comp
     * will fire for all comps for the hooks name.
     * @param {function} callback function to execute.
      */

  }, {
    key: 'registerHook',
    value: function registerHook(hookName, compType, callback) {
      this.validateHookName(hookName);
      if (!callback) {
        return;
      }

      var hook = this._hooks[hookName];
      if (!hook) {
        this._hooks[hookName] = hook = {};
      }

      compType = compType || ALL_COMPS_TYPE;
      var hookForComp = hook[compType];
      if (!hookForComp) {
        hook[compType] = hookForComp = [];
      }

      hookForComp.push(callback);
    }
  }, {
    key: 'HOOKS',
    get: function get() {
      return HOOKS;
    }
  }]);

  return HooksManager;
}();

module.exports = HooksManager;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var modelUtils = __webpack_require__(9);
var DELIMITER = '__';
var SPLITTED_DATA_TYPES = ['data', 'design'];

/* get Array[ids] or Array[{_id:id}] and returns array of id's*/
function getIdsFromItems(items) {
  return _.map(items, function (item) {
    return _.isString(item) ? item : item._id;
  });
}

/*get Array[ids] or Array[{_id:id}] and returns format of {item: itemData, index: index in array}*/
function reduceItems(data, ids) {
  var dataFormatted = _.map(data, function (v) {
    if (_.isString(v)) {
      return { _id: v };
    }
    return v;
  });
  return _.reduce(dataFormatted, function (result, item, index) {
    if (_.includes(ids, item._id)) {
      result.push({ item: item, index: index });
    }
    return result;
  }, []);
}

/*return added repeater items - check what newly ids were added
 * return {item: itemData, index: index in array} */
function getAddedItems(currentData, newData) {
  var newItemsIds = getIdsFromItems(newData);
  var currentDataIds = getIdsFromItems(currentData);
  var newlyAddedItemsIds = _.difference(newItemsIds, currentDataIds);
  return reduceItems(newData, newlyAddedItemsIds);
}

/*return removed repeater items - check what ids were removed
 * return {item: itemData, index: index in array} */
function getRemovedItems(currentData, newData) {
  var newItemsIds = getIdsFromItems(newData);
  var currentDataIds = getIdsFromItems(currentData);
  var removedIds = _.difference(currentDataIds, newItemsIds);
  return reduceItems(currentData, removedIds);
}

function getUniqueDisplayedId(originalId, itemId) {
  return originalId + DELIMITER + itemId;
}

function getOriginalId(uniqueItemId) {
  if (!uniqueItemId) {
    return;
  }
  return uniqueItemId.split(DELIMITER)[0];
}

function getItemId(uniqueItemId) {
  if (!uniqueItemId) {
    return;
  }
  return uniqueItemId.split(DELIMITER)[1];
}

function getTemplateCompIds(RMI, repeaterId, itemsData) {
  var templateCompIds = modelUtils.getAllCompsUnderRoot(_.get(RMI, '_model'), repeaterId);
  var itemsId = _.compact(_.map(itemsData, function (itemData) {
    return _.get(itemData, 'item._id');
  }));
  return _.reduce(itemsId, function (result, itemId) {
    return result.concat(_.map(templateCompIds, function (templateCompId) {
      return getUniqueDisplayedId(templateCompId, itemId);
    }));
  }, []);
}

module.exports = {
  getAddedItems: getAddedItems,
  getRemovedItems: getRemovedItems,
  getUniqueDisplayedId: getUniqueDisplayedId,
  getOriginalId: getOriginalId,
  getItemId: getItemId,
  getTemplateCompIds: getTemplateCompIds,
  SPLITTED_DATA_TYPES: SPLITTED_DATA_TYPES
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RemoteModelInterface = __webpack_require__(11);
var linkUtils = __webpack_require__(12);
var uriUtils = __webpack_require__(16);
var richTextUtils = __webpack_require__(13);
var videoUrlsUtils = __webpack_require__(8);
var repeaterUtils = __webpack_require__(1);
var TypeUtils = __webpack_require__(15);
var backgroundUtils = __webpack_require__(6);
var svgUtils = __webpack_require__(7);
var typeData = __webpack_require__(14);
var componentsHooks = __webpack_require__(10);

module.exports = {
  RemoteModelInterface: RemoteModelInterface,
  linkUtils: linkUtils,
  uriUtils: uriUtils,
  richTextUtils: richTextUtils,
  videoUrlsUtils: videoUrlsUtils,
  repeaterUtils: repeaterUtils,
  backgroundUtils: backgroundUtils,
  svgUtils: svgUtils,
  componentsHooks: componentsHooks,
  typeUtils: new TypeUtils(typeData)
};

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// platformUtils-bundle.js